

function PickupReturnDetailDetailController() {
    this.constructor.apply(this, arguments);
}

PickupReturnDetailDetailController.$inject = ['$scope', '$state', 'VehicleBookingService', '$mdDialog', '$stateParams', '$mdPanel', 'AttackmentService'];
PickupReturnDetailDetailController.prototype = {
    constructor($scope, $state, VehicleBookingService, $mdDialog, $stateParams, $mdPanel, AttackmentService) {
        this.$scope = $scope;
        this.$state = $state;
        this.vehicleBookingService = VehicleBookingService;
        this.$mdDialog = $mdDialog;
        this.$stateParams = $stateParams;
        this.$mdPanel = $mdPanel;
        this.attackmentService = AttackmentService;

        this.item = {};
        /** @type {IVehicleBooking} */
        let item = this.$scope.item;
        if (this.$scope.type === 'pickup') {
            this.item = {
                Id: item.Id,
                Date: item.PickUpDate,
                Time: item.PickUpTime,
                OdometerReading: item.PickUpOdometerReading,
                Attachments: item.PickUpAttachments,
                Questionnaire: item.PickUpQuestionnaire,
            };
        } else {
            this.item = {
                Id: item.Id,
                Date: item.ReturnDate,
                Time: item.ReturnTime,
                OdometerReading: item.ReturnOdometerReading,
                Attachments: item.ReturnAttachments,
                Questionnaire: item.ReturnQuestionnaire
            }
        }
        /** @type {VehicleBookingAttachment[]} Get attachments from vehicle booking(Old version) */
        this.attachments = this.attackmentService.getAttachmentFiles(this.item.Attachments);


        /** @type IVehicleDamage[] */
        this.vehicleDamages = [];

        /** @type VehicleBookingAttachment[] */
        this.damagesAttachments = [];

        // Get new damages
        if (this.item.Questionnaire && this.item.Questionnaire.NewDamages) {
            this.vehicleDamages = this.item.Questionnaire.NewDamages;
            this.damagesAttachments = this.getAttachmentsFromDamages(this.vehicleDamages);
        }


    },

    /**
     *
     * @param damages
     * @returns {*}
     */
    getAttachmentsFromDamages(damages) {
        return damages.map((damage) => {
            return this.vehicleBookingService.getAttachmentFromDamage(damage);
        });
    },

    getClass($file) {
        if (!$file.DocumentId) {
            return "no_image";
        }
    },

    onFileSelected($file) {
        let damage = this.vehicleDamages.find((damage) => {
            return damage.Id === $file.Id;
        });
        this.vehicleBookingService.onViewDamageDetail(damage);
    }

}

angular.module('internal.vehiclebookings').directive('pickupReturnDetail', function () {
    return {
        restrict: 'E',
        templateUrl: 'js/internal/vehiclebookings/directives/pickup-return-detail/pickup-return-detail.html',
        controllerAs: 'vm',
        replace: false,
        controller: PickupReturnDetailDetailController,
        scope: {
            item: '=',
            type: '@'
        },
    };
});